import { ja } from 'date-fns/locale';
const dateJaJP = {
  name: 'ja-JP',
  locale: ja
};
export default dateJaJP;